import { Skeleton } from "@/components/ui/skeleton";

const LoadingSkeleton = () => (
    <div className="space-y-8">
      {[1, 2, 3].map((i) => (
        <div key={i} className="space-y-4">
          <Skeleton className="h-10 w-3/4" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((j) => (
              <Skeleton key={j} className="h-[200px] w-full rounded-lg" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
  
  export default LoadingSkeleton;
  